import { useQuery } from '@tanstack/react-query'
import { Assessment } from '../types/assessment'
import { assessmentService } from '../services/assessmentService'
import { format } from 'date-fns'
import './AssessmentList.css'

interface AssessmentListProps {
  patientId: string
  consultationId?: string
  onSelect?: (assessment: Assessment) => void
}

export function AssessmentList({ patientId, consultationId, onSelect }: AssessmentListProps) {
  const { data: assessments, isLoading, error } = useQuery<Assessment[]>({
    queryKey: ['assessments', patientId, consultationId],
    queryFn: () => assessmentService.getAll(patientId, consultationId ? { consultationId } : undefined),
  })

  if (isLoading) return <div className="assessment-list-loading">Loading assessments...</div>
  if (error) return <div className="assessment-list-error">Error loading assessments</div>
  if (!assessments || assessments.length === 0) {
    return <div className="assessment-list-empty">No assessments found</div>
  }

  return (
    <div className="assessment-list">
      {assessments.map((assessment) => (
        <div
          key={assessment.id}
          className="assessment-item"
          onClick={() => onSelect?.(assessment)}
          role="button"
          tabIndex={0}
        >
          <div className="assessment-header">
            <div className="assessment-date">
              {format(new Date(assessment.assessmentDate), 'MMM dd, yyyy')}
            </div>
            <div className="assessment-status">
              <span className={`status-badge status-${assessment.status}`}>{assessment.status}</span>
            </div>
          </div>
          {assessment.assessedByName && (
            <div className="assessment-assessor">Assessed by: {assessment.assessedByName}</div>
          )}
          {assessment.chiefComplaint && (
            <div className="assessment-complaint">
              <strong>Chief Complaint:</strong> {assessment.chiefComplaint}
            </div>
          )}
          {assessment.assessment && (
            <div className="assessment-summary">{assessment.assessment}</div>
          )}
        </div>
      ))}
    </div>
  )
}
